export interface StateInfo {
  name: string;
  abbr: string;
  fips: string;
  neighbors: string[];
}

export const STATES: StateInfo[] = [
  { name: 'Alabama', abbr: 'AL', fips: '01', neighbors: ['FL', 'GA', 'MS', 'TN'] },
  { name: 'Alaska', abbr: 'AK', fips: '02', neighbors: [] },
  { name: 'Arizona', abbr: 'AZ', fips: '04', neighbors: ['CA', 'CO', 'NM', 'NV', 'UT'] },
  { name: 'Arkansas', abbr: 'AR', fips: '05', neighbors: ['LA', 'MO', 'MS', 'OK', 'TN', 'TX'] },
  { name: 'California', abbr: 'CA', fips: '06', neighbors: ['AZ', 'NV', 'OR'] },
  { name: 'Colorado', abbr: 'CO', fips: '08', neighbors: ['AZ', 'KS', 'NE', 'NM', 'OK', 'UT', 'WY'] },
  { name: 'Connecticut', abbr: 'CT', fips: '09', neighbors: ['MA', 'NY', 'RI'] },
  { name: 'Delaware', abbr: 'DE', fips: '10', neighbors: ['MD', 'NJ', 'PA'] },
  { name: 'Florida', abbr: 'FL', fips: '12', neighbors: ['AL', 'GA'] },
  { name: 'Georgia', abbr: 'GA', fips: '13', neighbors: ['AL', 'FL', 'NC', 'SC', 'TN'] },
  { name: 'Hawaii', abbr: 'HI', fips: '15', neighbors: [] },
  { name: 'Idaho', abbr: 'ID', fips: '16', neighbors: ['MT', 'NV', 'OR', 'UT', 'WA', 'WY'] },
  { name: 'Illinois', abbr: 'IL', fips: '17', neighbors: ['IA', 'IN', 'KY', 'MO', 'WI'] },
  { name: 'Indiana', abbr: 'IN', fips: '18', neighbors: ['IL', 'KY', 'MI', 'OH'] },
  { name: 'Iowa', abbr: 'IA', fips: '19', neighbors: ['IL', 'MN', 'MO', 'NE', 'SD', 'WI'] },
  { name: 'Kansas', abbr: 'KS', fips: '20', neighbors: ['CO', 'MO', 'NE', 'OK'] },
  { name: 'Kentucky', abbr: 'KY', fips: '21', neighbors: ['IL', 'IN', 'MO', 'OH', 'TN', 'VA', 'WV'] },
  { name: 'Louisiana', abbr: 'LA', fips: '22', neighbors: ['AR', 'MS', 'TX'] },
  { name: 'Maine', abbr: 'ME', fips: '23', neighbors: ['NH'] },
  { name: 'Maryland', abbr: 'MD', fips: '24', neighbors: ['DE', 'PA', 'VA', 'WV'] },
  { name: 'Massachusetts', abbr: 'MA', fips: '25', neighbors: ['CT', 'NH', 'NY', 'RI', 'VT'] },
  { name: 'Michigan', abbr: 'MI', fips: '26', neighbors: ['IN', 'OH', 'WI'] },
  { name: 'Minnesota', abbr: 'MN', fips: '27', neighbors: ['IA', 'ND', 'SD', 'WI'] },
  { name: 'Mississippi', abbr: 'MS', fips: '28', neighbors: ['AL', 'AR', 'LA', 'TN'] },
  { name: 'Missouri', abbr: 'MO', fips: '29', neighbors: ['AR', 'IA', 'IL', 'KS', 'KY', 'NE', 'OK', 'TN'] },
  { name: 'Montana', abbr: 'MT', fips: '30', neighbors: ['ID', 'ND', 'SD', 'WY'] },
  { name: 'Nebraska', abbr: 'NE', fips: '31', neighbors: ['CO', 'IA', 'KS', 'MO', 'SD', 'WY'] },
  { name: 'Nevada', abbr: 'NV', fips: '32', neighbors: ['AZ', 'CA', 'ID', 'OR', 'UT'] },
  { name: 'New Hampshire', abbr: 'NH', fips: '33', neighbors: ['MA', 'ME', 'VT'] },
  { name: 'New Jersey', abbr: 'NJ', fips: '34', neighbors: ['DE', 'NY', 'PA'] },
  { name: 'New Mexico', abbr: 'NM', fips: '35', neighbors: ['AZ', 'CO', 'OK', 'TX', 'UT'] },
  { name: 'New York', abbr: 'NY', fips: '36', neighbors: ['CT', 'MA', 'NJ', 'PA', 'VT'] },
  { name: 'North Carolina', abbr: 'NC', fips: '37', neighbors: ['GA', 'SC', 'TN', 'VA'] },
  { name: 'North Dakota', abbr: 'ND', fips: '38', neighbors: ['MN', 'MT', 'SD'] },
  { name: 'Ohio', abbr: 'OH', fips: '39', neighbors: ['IN', 'KY', 'MI', 'PA', 'WV'] },
  { name: 'Oklahoma', abbr: 'OK', fips: '40', neighbors: ['AR', 'CO', 'KS', 'MO', 'NM', 'TX'] },
  { name: 'Oregon', abbr: 'OR', fips: '41', neighbors: ['CA', 'ID', 'NV', 'WA'] },
  { name: 'Pennsylvania', abbr: 'PA', fips: '42', neighbors: ['DE', 'MD', 'NJ', 'NY', 'OH', 'WV'] },
  { name: 'Rhode Island', abbr: 'RI', fips: '44', neighbors: ['CT', 'MA'] },
  { name: 'South Carolina', abbr: 'SC', fips: '45', neighbors: ['GA', 'NC'] },
  { name: 'South Dakota', abbr: 'SD', fips: '46', neighbors: ['IA', 'MN', 'MT', 'ND', 'NE', 'WY'] },
  { name: 'Tennessee', abbr: 'TN', fips: '47', neighbors: ['AL', 'AR', 'GA', 'KY', 'MO', 'MS', 'NC', 'VA'] },
  { name: 'Texas', abbr: 'TX', fips: '48', neighbors: ['AR', 'LA', 'NM', 'OK'] },
  { name: 'Utah', abbr: 'UT', fips: '49', neighbors: ['AZ', 'CO', 'ID', 'NV', 'NM', 'WY'] },
  { name: 'Vermont', abbr: 'VT', fips: '50', neighbors: ['MA', 'NH', 'NY'] },
  { name: 'Virginia', abbr: 'VA', fips: '51', neighbors: ['KY', 'MD', 'NC', 'TN', 'WV'] },
  { name: 'Washington', abbr: 'WA', fips: '53', neighbors: ['ID', 'OR'] },
  { name: 'West Virginia', abbr: 'WV', fips: '54', neighbors: ['KY', 'MD', 'OH', 'PA', 'VA'] },
  { name: 'Wisconsin', abbr: 'WI', fips: '55', neighbors: ['IA', 'IL', 'MI', 'MN'] },
  { name: 'Wyoming', abbr: 'WY', fips: '56', neighbors: ['CO', 'ID', 'MT', 'NE', 'SD', 'UT'] },
  { name: 'District of Columbia', abbr: 'DC', fips: '11', neighbors: ['MD', 'VA'] },
];

export const SPECIAL_PLATES = [
  { name: 'Mexico', abbr: 'MEX', fips: '', neighbors: [] as string[] },
  { name: 'Canada', abbr: 'CAN', fips: '', neighbors: [] as string[] },
];

export const STATE_NAME_TO_ABBR: Record<string, string> = Object.fromEntries(
  STATES.map(s => [s.name, s.abbr])
);

export const STATE_ABBR_TO_NAME: Record<string, string> = Object.fromEntries(
  STATES.map(s => [s.abbr, s.name])
);

export const STATE_ABBR_TO_FIPS: Record<string, string> = Object.fromEntries(
  STATES.map(s => [s.abbr, s.fips])
);

export function getStateByAbbr(abbr: string): StateInfo | undefined {
  return STATES.find(s => s.abbr === abbr);
}

export function getNeighbors(stateAbbr: string): string[] {
  return getStateByAbbr(stateAbbr)?.neighbors ?? [];
}

export function getStateName(abbr: string): string {
  if (abbr === 'MEX') return 'Mexico';
  if (abbr === 'CAN') return 'Canada';
  return STATE_ABBR_TO_NAME[abbr] ?? abbr;
}
